/**
 * Survey notification configuration.
 */

export const SURVEY_URL = "https://www.surveymonkey.com/r/2C7BNR8";
export const SURVEY_NOTIFICATION_COOKIE = "hideSurveyNotification";
// 10 years - effectively permanent
export const SURVEY_COOKIE_EXPIRY_DAYS = 3650;

// Set to false to disable the survey entirely.
export const ENABLE_SURVEY = false;

// The survey will stop showing after this date. Set to null for no expiration.
export const SURVEY_RUNS_UNTIL = new Date( "2026-04-15" );
